import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefresh2 = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgRefresh2" data-sentry-source-file="Refresh2.tsx">
            <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5} d='M22 12c0 5.52-4.48 10-10 10s-8.89-5.56-8.89-5.56m0 0h4.52m-4.52 0v5M2 12C2 6.48 6.44 2 12 2c6.67 0 10 5.56 10 5.56m0 0v-5m0 5h-4.44' data-sentry-element="path" data-sentry-source-file="Refresh2.tsx" />
        </svg>;
};
export default SvgRefresh2;